import { get, httpDelete, patch, post } from '../../utils/http';

export const fetchTags = ({ accountId }) => get(`/accounts/${accountId}/tags`);

export const addTag = ({ accountId, tag }) => post(`/accounts/${accountId}/tags`, tag);

export const updateTag = ({ accountId, tagId, tag }) => patch(`/accounts/${accountId}/tags/${tagId}`, tag);

export const deleteTag = ({ accountId, tagId }) => httpDelete(`/accounts/${accountId}/tags/${tagId}`);
